import { createActionCreator } from "deox";

export const loadOverDueInit = createActionCreator("loadOverDueInit");

export const showOverDue = createActionCreator("showOverDue");
export const hideOverDue = createActionCreator("hideOverDue");
